<template>
    <div>
        <breadcrumbs :dom="crumbsItem" />
        <div class="cart_info">
            <form>
                <Product v-for="(product, index) in products" v-bind:key="index" :product="product" :index="index" />
                <div class="total">
                    <div class="row justify-content-end align-items-end">
                        <div class="col-auto col-sm-auto align-self-end">
                            <p>總金額</p>
                        </div>
                        <div class="col-auto align-self-end"><span>{{ cartTotalPrice | currency }}</span></div>
                    </div>
                </div>
                <!-- 暫時隱藏 -->
                <!-- <div class="send_box">
                    <div class="row justify-content-between align-items-end">
                        <div class="col-sm-5 col-lg-4">
                            <router-link to="/" class="hoverFill">&lt; 繼續瀏覽課程</router-link>
                        </div>
                        <div class="col-sm-6 col-lg-5 text-right">
                            <button v-if="products.length" type="button" class="store_btn hoverShallow" @click="send">前往結帳</button>
                        </div>
                    </div>
                </div> -->
            </form>
        </div>
        <div class="payment">
            <form>
                <!-- 暫時隱藏 -->
                <!-- <Product v-for="(product, index) in products" v-bind:key="index" :index="index" :product="product"
                    :isEdit="false" /> -->
                <div  class="payment_content">
                    <div class="row" v-if="!paymentContentHide">
                        <div class="col-xl-6" v-if="!justInvoice">
                            <h3>付款方式</h3>
                            <div class="errors_box">
                                <span>{{ errors.first('pay_meth') }}</span>
                            </div>
                            <div class="pay_meth">
                                <input v-model="PayType" v-validate="'required'" value="3" id="pay_meth1" type="radio" name="pay_meth">
                                <label for="pay_meth1">
                                    <h5 class="arrow area">線上刷卡</h5>
                                    <h6>信用卡號</h6>
                                    <div class="errors_box">
                                        <span>{{ errors.first('creditCardFake1') }}</span>
                                        <span>{{ errors.first('creditCardFake2') }}</span>
                                        <span>{{ errors.first('creditCardFake3') }}</span>
                                        <span>{{ errors.first('creditCardFake4') }}</span>
                                        <span>{{ errors.first('creditCardNO') }}</span>
                                    </div>
                                    <div class="row creditCardFakeBox">
                                        <div class="col-md-3">
                                            <input v-model="CreditCardFake1" v-validate="creditCardFakeRule" name="creditCardFake1" class="store_input creditCardFake" type="text" maxlength="4" placeholder="1111" @input="pushCreditCard" />
                                        </div>
                                        <div class="col-md-3">
                                            <input v-model="CreditCardFake2" v-validate="creditCardFakeRule" name="creditCardFake2" class="store_input creditCardFake" type="text" maxlength="4" placeholder="1111" @input="pushCreditCard" />
                                        </div>
                                        <div class="col-md-3">
                                            <input v-model="CreditCardFake3" v-validate="creditCardFakeRule" name="creditCardFake3" class="store_input creditCardFake" type="text" maxlength="4" placeholder="1111" @input="pushCreditCard" />
                                        </div>
                                        <div class="col-md-3">
                                            <input v-model="CreditCardFake4" v-validate="creditCardFakeRule" name="creditCardFake4" class="store_input creditCardFake" type="text" maxlength="4" placeholder="1111" @input="pushCreditCard" />
                                        </div>
                                    </div>
                                    <input hidden v-model="CreditCardNO" v-validate="creditCardNoRule" name="creditCardNO" class="store_input" type="text" maxlength="16" placeholder="1111 1111 1111 1111" />
                                    <h6>請輸入卡號</h6>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <p>卡片末三碼</p>
                                            <div class="errors_box">
                                                <span>{{ errors.first('cvc') }}</span>
                                            </div>
                                            <input v-model="CVC" v-validate="cvcRule" name="cvc" class="store_input" type="text" maxlength="3" placeholder="***" />
                                        </div>
                                        <div class="col-sm-6">
                                            <p>有效年月</p>
                                            <div class="errors_box">
                                                <span>{{ errors.first('validDate') }}</span>
                                            </div>
                                            <div class="date_box">
                                                <input v-model="ValidDate" v-validate="validDateRule" name="validDate" class="store_input" type="text" maxlength="4" placeholder="MMYY" />
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <!-- 暫時隱藏
                            <div class="pay_meth">
                                <input v-model="PayType" v-validate="'required'" value="4" id="pay_meth2" type="radio" name="pay_meth">
                                <label for="pay_meth2">
                                    <h5 class="area">ATM轉帳付款</h5>
                                </label>
                            </div>
                             -->
                            <!-- <div class="pay_meth">
                                <input v-model="PayType" v-validate="'required'" value="5" id="pay_meth3" type="radio" name="pay_meth">
                                <label for="pay_meth3">
                                    <h5 class="area">Line Pay</h5>
                                </label>
                            </div>
                            <div class="pay_meth">
                                <input v-model="PayType" v-validate="'required'" value="6" id="pay_meth4" type="radio" name="pay_meth">
                                <label for="pay_meth4">
                                    <h5 class="area">街口支付</h5>
                                </label>
                            </div> -->
                        </div>
                        <div class="col-xl-6">
                            <h3>
                                發票開立
                                <span>紙本發票於上課前到店領取</span>
                            </h3>
                            <div class="errors_box">
                                <span>{{ errors.first('invoice') }}</span>
                            </div>
                            <div class="invoice">
                                <input v-model="invoiceType" v-validate="'required'" value="1" id="invoice1" type="radio" name="invoice">
                                <label for="invoice1">
                                    <h5 class="area">存入特力屋會員</h5>
                                </label>
                            </div>
                            <div class="invoice">
                                <input v-model="invoiceType" v-validate="'required'" value="2" id="invoice2" type="radio" name="invoice">
                                <label for="invoice2">
                                    <h5 class="arrow area">列印紙本發票</h5>
                                    <h6>統一編號</h6>
                                    <div class="errors_box">
                                        <span>{{ errors.first('vatNO') }}</span>
                                    </div>
                                    <input v-model="VatNO" v-validate="validVatNORule" name="vatNO" class="store_input" type="text" placeholder="請輸入統一編號" />
                                </label>
                            </div>
                            <div class="invoice">
                                <input v-model="invoiceType" v-validate="'required'" value="3" id="invoice3" type="radio" name="invoice">
                                <label for="invoice3">
                                    <h5 class="arrow area">手機條碼載具</h5>
                                    <div class="errors_box">
                                        <span>{{ errors.first('carrierBarcode') }}</span>
                                    </div>
                                    <input v-model="carrierBarcode" v-validate="carrierBarcodeRule" name="carrierBarcode" class="store_input" type="text" maxlength="8" placeholder="請輸入手機條碼 (如 /ABC1234)" />
                                </label>
                            </div>
                            <div class="invoice">
                                <input v-model="invoiceType" v-validate="'required'" value="4" id="invoice4" type="radio" name="invoice">
                                <label for="invoice4">
                                    <h5 class="arrow area">自然人憑證載具</h5>
                                    <div class="errors_box">
                                        <span>{{ errors.first('naturalPersonBarcode') }}</span>
                                    </div>
                                    <input v-model="carrierBarcode" v-validate="naturalPersonBarcodeRule" name="naturalPersonBarcode" class="store_input" type="text" maxlength="16" placeholder="請輸入自然人憑證條碼" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 暫時隱藏 -->
                <!-- <div class="total">
                    <div class="row justify-content-end align-items-end">
                        <div class="col-auto col-sm-auto align-self-end">
                            <p>總金額</p>
                        </div>
                        <div class="col-auto align-self-end"><span>{{ cartTotalPrice | currency }}</span></div>
                    </div>
                </div> -->
                <div class="send_box">
                    <div class="row justify-content-between align-items-end">
                        <div class="col-sm-5 col-lg-4">
                            <router-link :to="{ name: 'tlw_home' }" class="hoverFill">&lt; 繼續購物</router-link>
                        </div>
                        <div class="col-sm-6 col-lg-5 text-right">
                            <button type="button" class="store_btn hoverShallow" @click="send">前往付款</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import Breadcrumbs from '@/components/partial/Breadcrumbs';
import Product from '@/components/cart/partials/Product';
import { mapGetters, mapMutations } from 'vuex';
import orderApi from '@/api/order';
import moment from 'moment';
import { Base64 } from 'js-base64';

export default {
  components: {
    Breadcrumbs,
    Product
  },
  data() {
    return {
      crumbsItem: [
        {
          text: '首頁',
          to: {
            name: 'home'
          }
        },
        {
          text: '購物車',
          active: true
        }
      ],
      VatNO: '',
      CreditCardFake1: '',
      CreditCardFake2: '',
      CreditCardFake3: '',
      CreditCardFake4: '',
      CreditCardNO: '',
      ValidDate: '',
      CVC: '',
      PayType: '3',
      invoiceType: '1',
      carrierBarcode: ''
    };
  },
  computed: {
    ...mapGetters('cart', ['products', 'cartTotalPrice']),

    allCouponNum() {
      return this.products.map(product => {
        return {
          title: product.title,
          accountNo: product.ticketNo
        };
      });
    },

    allEnjoyNum() {
      return this.products.map(product => {
        return {
          title: product.title,
          accountNo: product.enjoyDefaultNum
        };
      });
    },

    allEnjoyEndDate() {
      return this.products.map(product => {
        return {
          title: product.title,
          endDate: product.balanceEnjoy.ValidityEndDate
            ? product.balanceEnjoy.ValidityEndDate
            : product.denomination.ValidityEndDate
        };
      });
    },

    //所有的紅利點數折抵
    allBonusDis() {
      return this.products.map(product => {
        return product.bonusDis ? product.bonusDis : 0;
      });
    },
    //紅利點數折抵總金額
    totalBonusDis() {
      if (this.allBonusDis.length !== 0) {
        return this.sumData(this.allBonusDis);
      } else {
        return 0;
      }
    },
    //所有的即享券折抵
    allEnjoyDis() {
      return this.products.map(product => {
        return product.enjoyDis ? product.enjoyDis : 0;
      });
    },
    //即享券折抵總金額
    totalEnjoyDis() {
      if (this.allEnjoyDis.length !== 0) {
        return this.sumData(this.allEnjoyDis);
      } else {
        return 0;
      }
    },
    //所有的折價券折抵
    allCouponDis() {
      return this.products.map(product => {
        return product.couponDis ? product.couponDis : 0;
      });
    },
    //折價券折抵總金額
    totalCouponDis() {
      if (this.allCouponDis.length !== 0) {
        return this.sumData(this.allCouponDis);
      } else {
        return 0;
      }
    },

    //隱藏付款方式以及發票開立
    paymentContentHide() {
      if (
        this.cartTotalPrice == 0 &&
        this.totalBonusDis == 0 &&
        this.totalEnjoyDis == 0 &&
        this.totalCouponDis == 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    justInvoice() {
      if (
        this.cartTotalPrice == 0 &&
        (this.totalBonusDis !== 0 ||
          this.totalEnjoyDis !== 0 ||
          this.totalCouponDis !== 0)
      ) {
        return true;
      } else {
        return false;
      }
    },

    product() {
      return this.products.map(product => product);
    },
    OrderGroup() {
      return this.products.map(product => {
        return {
          BranchRoomID: product.BranchRoomID,
          ClassBranchID: product.ClassBranchId,
          InitID: product.id,
          BranchID: product.BranchRoomID.slice(0, 4),
          EventMastId: product.EventMastId ? product.EventMastId : null,
          EventDetlId: product.EventDetlId ? product.EventDetlId : null,
          DESCRITPION: product.DESCRITPION ? product.DESCRITPION : null,
          BonusPoints: product.RbonusPoints ? product.RbonusPoints : 0,
          Payoff: product.bonusDis ? product.bonusDis : 0,
          DiscTypePoint: product.DiscTypePoint ? product.DiscTypePoint : null,
          DscSku: product.DscSku ? product.DscSku : null,
          SkuNoPoint: product.SkuNoPoint ? product.SkuNoPoint : null,
          DiscAmnt30: product.enjoyDis ? product.enjoyDis : 0,
          SkuNo30: product.SkuNo30 ? product.SkuNo30 : null,
          ReturnSkuNo30: product.ReturnSkuNo30 ? product.ReturnSkuNo30 : null,
          DiscType30: product.DiscType30 ? product.DiscType30 : null,
          Grno30: product.Grno30 ? product.Grno30 : null,
          rebateName30: product.rebateName30 ? product.rebateName30 : null,
          accountType: product.accountType ? product.accountType : null,
          accountNo: product.enjoyDefaultNum ? product.enjoyDefaultNum : null,
          copu_type: product.copu_type ? product.copu_type : null,
          DiscAmnt10: product.couponDis ? product.couponDis : 0,
          SkuNo10: product.SkuNo10 ? product.SkuNo10 : null,
          ReturnSkuNo10: product.ReturnSkuNo10 ? product.ReturnSkuNo10 : null,
          DiscType10: product.DiscType10 ? product.DiscType10 : null,
          Grno10: product.Grno10 ? product.Grno10 : null,
          tickectSeq: product.ticketNo ? product.ticketNo : null,
          rebateName10: product.rebateName10 ? product.rebateName10 : null,

          StudentGroup: product.users.map(user => {
            return {
              Name: user.name,
              Email: user.email,
              CellPhone: user.phone
            };
          })
        };
      });
    },
    creditCardNoRule() {
      return this.PayType == '3' ? 'required|credit_card' : '';
    },
    creditCardFakeRule() {
      return this.PayType == '3' ? 'required|numeric|length:4' : '';
    },
    cvcRule() {
      return this.PayType == '3' ? 'required|numeric|length:3' : '';
    },
    validDateRule() {
      return this.PayType == '3' ? 'required|date_format:MMyy' : '';
    },
    validVatNORule() {
      return 'company_serial_no';
    },
    carrierBarcodeRule() {
      if (this.invoiceType != '3') return '';
      return 'required|mobile_barcode';
    },
    naturalPersonBarcodeRule() {
      if (this.invoiceType != '4') return '';
      return 'required|natural_person_cert';
    },
    type() {
      if (this.cartTotalPrice > 0) {
        if (this.PayType == '3') {
          return 'Credit';
        } else if (this.PayType == '4') {
          return 'ATM';
        }
      }

      return 'Free';
    }
  },
  created() {
    const dict = {
      custom: {
        cvc: {
          length: '請輸入正確資訊'
        },
        creditCardFake1: {
          length: '第一格請輸入正確資訊'
        },
        creditCardFake2: {
          length: '第二格請輸入正確資訊'
        },
        creditCardFake3: {
          length: '第三格請輸入正確資訊'
        },
        creditCardFake4: {
          length: '第四格請輸入正確資訊'
        },
        vatNO: {
          company_serial_no: field => `請輸入正確${field}`
        }
      },
      attributes: {
        pay_meth: '付款方式',
        creditCardNO: '信用卡號',
        creditCardFake1: '第一格信用卡號',
        creditCardFake2: '第二格信用卡號',
        creditCardFake3: '第三格信用卡號',
        creditCardFake4: '第四格信用卡號',
        cvc: '卡片末三碼',
        validDate: '有效年月',
        invoice: '發票開立方式',
        vatNO: '統一編號',
        carrierBarcode: '手機條碼',
        naturalPersonBarcode: '自然人憑證條碼'
      }
    };

    this.$validator.extend('mobile_barcode', {
      getMessage: () => '請輸入正確的手機條碼（/ 開頭共 8 碼）',
      validate: value => {
        if (value.length !== 8 || value[0] !== '/') return false;
        const allowed = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+-.';
        return [...value.slice(1)].every(c => allowed.includes(c));
      }
    });

    this.$validator.extend('natural_person_cert', {
      getMessage: () => '請輸入正確的自然人憑證條碼（2 碼大寫英文 + 14 碼數字）',
      validate: value => {
        if (value.length !== 16) return false;
        const letters = value.substring(0, 2);
        const digits = value.substring(2);
        return /^[A-Z]{2}$/.test(letters) && /^\d{14}$/.test(digits);
      }
    });

    this.$validator.localize('zh_TW', dict);
  },
  watch: {
    invoiceType() {
      this.carrierBarcode = '';
    }
  },
  methods: {
    ...mapMutations('cart', ['setCartProducts']),

    sumData(arr) {
      return arr.reduce(
        (accumulator, currentValue) => accumulator + currentValue
      );
    },
    pushCreditCard() {
      let vm = this,
        fake1 = vm.CreditCardFake1,
        fake2 = vm.CreditCardFake2,
        fake3 = vm.CreditCardFake3,
        fake4 = vm.CreditCardFake4;
      vm.CreditCardNO = fake1 + fake2 + fake3 + fake4;
    },

    checkRepeat(couponType, couponText) {
      let arr = couponType.filter(item => {
        //檢查重複的若為折價券,折價券為9碼可以重複
        if (couponType == this.allCouponNum) {
          return item.accountNo && item.accountNo.toString().length !== 9;
        } else {
          return item.accountNo;
        }
      });
      let answer = [];
      let myArr = [];
      for (var i = 0; i < arr.length; i++) {
        var newArr = arr.filter(item => {
          return item.accountNo == arr[i].accountNo;
        });
        if (newArr.length > 1) {
          let noRepeat = myArr.indexOf(...newArr);
          if (noRepeat == -1) {
            myArr.push(...newArr);
          }
        }
      }
      answer = myArr.map(item => item.title);
      answer.forEach(item =>
        alert(item + `的${couponText}重複使用` + `請重新選擇${couponText}`)
      );
      if (answer.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    checkExpired() {
      let arr = this.allEnjoyEndDate.filter(item => {
        return (
          item.endDate &&
          moment(item.endDate).format('YYYY/MM/DD') <
            moment().format('YYYY/MM/DD')
        );
      });
      let ans = arr.map(item => item.title);
      ans.forEach(item => alert(item + `的即享券已經過期`));

      if (arr.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    send() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // window.location.href = this.crumbsItem[0].to
          // this.$router.push({
          //     name: 'cart.payment',
          // });

          //檢查折價券是否重複
          if (!this.checkRepeat(this.allCouponNum, '折價券')) {
            return;
          }

          //檢查即享券是否重複
          if (!this.checkRepeat(this.allEnjoyNum, '即享券')) {
            return;
          }

          //檢查即享券是否過期
          if (!this.checkExpired()) {
            return;
          }

          let type = this.type;

          orderApi.orderCreate(
            {
              OrderGroup: this.OrderGroup,
              VatNO: this.VatNO,
              CreditCardNO: Base64.encode(this.CreditCardNO),
              ValidDate: Base64.encode(this.ValidDate),
              CVC: this.CVC,
              PayType: this.PayType,
              IsPrintInvoice: this.invoiceType == '2',
              CarrierBarcode: this.carrierBarcode
            },
            data => {
              if (!data.ResponseMessage) {
                this.setCartProducts([]);
              }
              // 有hppUrl就跳轉到hppUrl
              // 銀行會call 後端拿到前端跳轉Url + query String 才跳到 result component
              // 沒有就直接跳result component
              if(!data.redirectUrl || data.redirectUrl === '') {
                this.$router.push({
                  name: 'cart.result',
                  params: {
                    result: data,
                    type: type
                  }
                });
              } else {
                window.location.href = data.redirectUrl;
              }
            }
          );
        }
      });
    }
  },
  mounted() {
    $('.creditCardFake').on('keyup', function(e) {
      if (
        e.which == 9 ||
        e.which == 37 ||
        e.which == 38 ||
        e.which == 39 ||
        e.which == 40
      )
        return;
      if ($(this).val().length == 4) {
        $(this)
          .parent()
          .next()
          .children()
          .focus();
      }
    });
  }
};
</script>
